/**
 * @fileoverview Contains routes for the socialstorm project
 *
 * @author Samantha Landen (slanden@yext.com)
 */

goog.provide('yext.social.routes');
goog.provide('yext.socialstorm.routes');

goog.require('yext.storm.routerDEPRECATED');

goog.scope(function() {
  var route = yext.storm.routerDEPRECATED.route;

  yext.socialstorm.routes.Social = {
    locationsSearchJson: route('social/post/locationsSearchJson'),
    postLocationsSearchJson: route('social/post/postLocationsSearchJson'),
    locationFilters: route('social/post/locationFilters'),
    fetchLinkMetadata: route('social/fetchLinkMetadata'),
    approveSuggestions: route('social/approveSuggestions'),
  };

  yext.socialstorm.routes.SocialPost = {
    likePost: route('social/post/like'),
    retweetStatus: route('social/post/retweetStatus'),
    createPost: route('social/post'),
    uploadPhoto: route('social/uploadPhoto'),
    getPost: route('social/post/:postId'),
    deletePost: route('social/post/:postId'),
    retryPost: route('social/retryPost'),
    declineRetry: route('social/declineRetry'),
    declineDeleteRetry: route('social/declineDeleteRetry'),
    createComment: route('social/post/:socialPostId/comment'),
    deleteComment: route('social/post/comments/:commentId'),
    likeComment: route('social/post/comments/:commentId/like'),
    getComments: route('social/post/comments'),
    loadPostHistoryPageWithParams: route('social/loadPostHistoryPageWithParams'),
    loadPostLocations: route('social/loadPostLocations'),
    checkPostStatus: route('social/checkPostStatus'),
    viewConversation: route('social/viewConversation'),
    retryDeletePost: route('social/retryDeletePost'),
    refreshTweets: route('social/refreshTweets'),
  };
});
